import { Controller } from "@hotwired/stimulus"

// Require a suggestion for typed locations. Empty optional fields remain valid.
export default class PlaceAutocompleteValidationController extends Controller {
  static values = {
    degradedSelector: { type: String, default: ".place-autocomplete-notice" },
    allowDegraded: { type: Boolean, default: true }
  }

  check(event) {
    // Even partial saves must validate typed places. Some forms allow lookup outages.
    if (this.allowDegradedValue && this.degraded()) return

    const offenders = this.offenders()
    if (!offenders.length) return

    event.preventDefault()
    event.stopImmediatePropagation()

    offenders.forEach((input) => this.report(input))
    this.focusFirst(offenders[0])
  }

  offenders() {
    return Array.from(this.element.querySelectorAll(".place-autocomplete-js")).filter((input) => {
      return !input.disabled && input.value.trim() && input.dataset.placeVerified !== "true"
    })
  }

  degraded() {
    const notice = document.querySelector(this.degradedSelectorValue)
    return Boolean(notice) && !notice.classList.contains("d-none")
  }

  report(input) {
    input.classList.add("is-invalid")
    input.closest(".ff-required")?.classList.add("ff-required-active")
  }

  focusFirst(input) {
    input.scrollIntoView({ block: "center", behavior: "smooth" })
    input.focus()
  }
}
